import authenticationService from '../../../services/authentication/AuthenticationService';

export default function shouldShowStats(userOrganisations) {
  return !authenticationService.roles().isBackOffice() &&
    userOrganisations &&
    userOrganisations.some(organisation => organisation.enabled);
}
